import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { CHART_COLORS, CHART_OPTIONS } from './constants';

export const DiscreteChart = ({ plot, yAxisLabel, startYear, endYear }) => {
  const labels = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);

  const emissionLabels = Array.from(new Set(plot?.flatMap(node => node.emissions.map(e => e.label))));

  const datasets = emissionLabels.map((emissionLabel, index) => ({
    label: emissionLabel,
    data: plot.map(node => {
      const emission = node.emissions.find(e => e.label === emissionLabel);
      return emission ? emission.quantity.scalar : 0;
    }),
    backgroundColor: CHART_COLORS[index],
  }));

  return (
    <Bar
      data={{ labels, datasets }}
      options={{
        ...CHART_OPTIONS,
        plugins: {
          ...CHART_OPTIONS.plugins,
          yAxisLabel: {
            ...CHART_OPTIONS.plugins.yAxisLabel,
            text: yAxisLabel,
          },
        },
      }}
    />
  );
};

DiscreteChart.propTypes = {
  plot: PropTypes.array,
  yAxisLabel: PropTypes.string,
  label: PropTypes.string,
  startYear: PropTypes.number,
  endYear: PropTypes.number,
};
